export enum TipoCuentaBancaria {
  CuentaCorriente = 1,
  CajaAhorro = 2,
}

export enum TipoMonedaDisplay {
  USD = "Dólares",
  ARS = "Pesos"
}

export enum TipoMoneda {
  USD = "USD",
  ARS = "ARS",
}

export enum TipoFijacion {
  Manual = "Manual",
  Automatica = "Automatica",
}

export enum CondicionFinanciera {
  Activa = 0,
  InactivaTotal = 1,
  InactivaParaPagos = 2,
}

export enum BeneficiaryAccountTypes {
  external = "External",
  internal = "Internal",
}

export enum BeneficiaryAccountTypesLabel {
  external = "Externa",
  internal = "Interna",
}

export enum TransferTransactionTypeEnum {
  AUTO = "Automatica",
  MANUAL = "Manual",
}

export enum RequestTypes {
  Efectivo = 1,
  Cheque = 2,
  ECheq = 3,
  Transferencia = 4,
  TransferenciaProgramada = 5,
  OrdenDeVenta = 6,
  ContraEntrega = 7,
  ContratoFuturo = 8,
  Cupos = 9,
  TransferenciaDiferida = 10,
  ChequeRespaldo = 11,
  CuposFertilizante = 12,
  CuposCombustible = 13,
}

export enum RequestStatusIds {
  //Solicitudes de Contacto
  PendienteDeContactoSolicitudContacto = 1,

  ContactadoSolicitudContacto = 2,

  SinValidar = 30,

  //Solicitudes (Efectivo, Transferencia, Etc)

  RequiereInformacion = 6,

  AProcesar = 10,

  Disponible = 14,

  Finalizada = 18,

  Rechazada = 22,

  Cancelada = 26,

  EnCurso = 34,

  Fallida = 38,

  //Programadas

  Programada = 42,

  EnRevision = 46,

  //Estados Granaria

  EnComunicacion = 50,

  //Cupos

  Pendiente = 54,

  CuposAsignadosParcialmente = 58,

  CuposAsignadosTotal = 62,

  //Cheques respaldo
  PendienteChequeRespaldo = 66,
  EnProcesoChequeRespaldo = 70,
  FinalizadoChequeRespaldo = 74,
  CanceladoChequeRespaldo = 78,

  Negociacion = 82,
  Confirmada = 86,

    // Solicitudes Insumos
   PendienteDeConfirmacion = 90,
   RequiereInformacionSolicitudInsumos = 94,
   PedidoCreado = 96,
   ConfirmadoParcial = 98,
   PedidoConfirmado = 102,
   EnCamino = 106,
   EntregaParcial = 110,
   EntregadoSolicitud = 114,

  // Rechazada sol. insumos
  RechazadaInsumos = 118,

  // Cancelada sol. insumos
  CanceladaInsumos = 122,

  // Pedidos
  PendientePedido = 126,
  ConfirmadoPedido = 130,
  EnTransitoPedido = 134,
  Entregado = 138
}

export enum EntityTypes {
  Request = 1,
  Contact = 2,
  BackupCheck = 3,
  SuppliesRequest = 4,
  SuppliesOrder = 5,
}

export enum MaintenanceModules {
    General = "GENERAL",
    Granaria = "GRANARY",
    Finanzas = "FINANCIAL",
    MercadoDelDia = "DAILY_MARKET",
    Otros = "OTHER",
    Insumos = "SUPPLIES",
}

export enum MaintenanceSections {
  GeneralApp = "GENERAL_APP",
  General = "GENERAL",

  // Granaria
  Slots = "SLOTS",
  SellOrder = "SELL_ORDER",
  Sales = "SALES",
  CashOnDelivery = "CASH_ON_DELIVERY",
  FutureContracts = "FUTURE_CONTRACTS",

  // Finanzas
  Cash = "CASH",
  Check = "CHECK",
  Transfer = "TRANSFER",
  FinancialMovements = "FINANCIAL_MOVEMENTS",

  // Cotizaciones
  PriceBoard = "PRICE_BOARD",
  UnionMarket = "UNION_MARKET",

  // Insumos en proceso

  // Otros
  UserProfile = "USER_PROFILE",
  Notifications = "NOTIFICATIONS",
  Sidebar = "SIDEBAR",
}

export enum TipoInsumos {
  Fertilizante = 1,
  Combustible = 2,
}